import { useCallback } from 'react';
import type { MouseEvent, ReactNode } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import type { NavLinkProps } from 'react-router-dom';
import { useUnsavedChanges } from '../contexts/UnsavedChangesContext';

type SafeNavLinkProps = Omit<NavLinkProps, 'to' | 'onClick' | 'children'> & {
  /** Nur String-Ziele — handleNavigationAttempt validiert lokale Pfade. */
  to: string;
  toggleMenu?: () => void;
  children?: ReactNode;
};

export default function SafeNavLink({ to, toggleMenu, children, ...props }: SafeNavLinkProps) {
  const { handleNavigationAttempt } = useUnsavedChanges();
  const navigate = useNavigate();

  const handleClick = useCallback((e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    setTimeout(() => {
      const shouldNavigate = handleNavigationAttempt(to);
      if (shouldNavigate) {
        navigate(to);
        if (toggleMenu) {
          toggleMenu();
        }
      }
    }, 0);
  }, [handleNavigationAttempt, navigate, to, toggleMenu]);

  return (
    <NavLink {...props} to={to} onClick={handleClick}>
      {children}
    </NavLink>
  );
}
